var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.store.isLoading)?_c('div',[_c('vue-element-loading',{attrs:{"active":_vm.store.isLoading,"spinner":"spinner","duration":"1.5","color":"#4f41a3","size":"60"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }